module.exports = __webpack_public_path__ + "img/spring.7776a917.webp";